export * from './src/automations-v2-activation-activations.schemas.js';
